import { Component, OnInit } from '@angular/core';
import { RouterPathService } from "../../core/common/variables/router-path.service";
import { ImagePathService } from "../../core/common/variables/image-path.service";
import { TranslateService } from "../common/variables/translate-service";
import { GlobalVariableService } from "../common/variables/global-variable";
import { Router } from '@angular/router';
import { GlobalService } from '../common/services/global.service';
import {
  FormBuilder,
  FormGroup,
  FormArray,
  FormControl,
  Validators
} from '@angular/forms';

@Component({
  selector: 'sen-app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit {

  projectPath: string;
  showPW: boolean = false;
  form: FormGroup;

  constructor(public globalService: GlobalService, private formBuilder: FormBuilder, private routerPath: RouterPathService, private router: Router, public global: GlobalVariableService, public imagePath: ImagePathService, public translate: TranslateService) {
    this.projectPath = this.routerPath.manageProjectPath;
    this.form = this.formBuilder.group({
      sPassword: new FormControl('', [Validators.required]),
      sUsername: new FormControl('', [Validators.required])
    });
  }

  ngOnInit(): void {
  }

  passwordRequest() {
    if (window.location.origin.includes("localhost")) {
      if (this.global.sLanguage == this.global.enString) {
        window.open(`${this.global.shopURL}${this.global.enString}/home/?cmd=password_request`);
      } else {
        window.open(`${this.global.shopURL}${this.global.deString}/home/?cmd=password_request`);
      }
    } else {
      if (this.global.sLanguage == this.global.enString) {
        window.open(`${window.location.origin}/${this.global.sLanguage}/home/?cmd=password_request`);
      } else {
        window.open(`${window.location.origin}/${this.global.sLanguage}/home/?cmd=password_request`);
      }
    }
  }

  login() {
    this.form.markAllAsTouched();
    if (this.form.invalid) return;
    const qParam = {
      cmd: this.global.login,
      userName: this.form.get('sUsername')!.value,
      password: this.form.get('sPassword')!.value
    };
    this.globalService.getData(qParam).subscribe((data: any) => {
      try {
        if (data.ok.data) {
          this.router.navigate([this.projectPath]);
        }
      } catch { }
    });
  }
}